<template>
  <div class="announcements">
    <div container>
      <transition v-on:enter="enter" v-on:leave="leave">
        <div
          class="announcement"
          v-if="announcement.length > 0"
          :class="[{ '-warning': isWarning }, modifier]"
        >
          <p>
            <span class="label" v-if="!isWarning">Success:</span>
            {{ announcement }}
          </p>
          <a href="javascript:void(0)" @click="clearAnnouncement" class="black">
            <font-awesome-icon icon="times" aria-label="Close"/>
          </a>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import accordionTransition from '@mixins/accordionTransition'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { eventBus } from '@/main'
  import { mapMutations } from 'vuex'

  export default {
    mixins: [accordionTransition],
    methods: {
      ...mapMutations({
        clearAnnouncement: 'CLEAR_ANNOUNCEMENT',
        setAnnouncement: 'SET_ANNOUNCEMENT',
        setAnnouncementWarning: 'SET_ANNOUNCEMENT_WARNING'
      })
    },
    props: {
      modifier: {
        type: String,
        default: ''
      }
    },
    components: {
      FontAwesomeIcon
    },
    computed: {
      announcement() {
        return this.$store.state.notifications.announcement
      },
      isWarning() {
        return this.$store.state.notifications.announcementIsWarning
      }
    },
    watch: {
      announcement(newAnnouncement, oldAnnouncement) {
        if (newAnnouncement.length) {
          setTimeout(() => {
            this.clearAnnouncement()
          }, 10000)
        }
      }
    },
    created() {
      eventBus.$on('setErrorCodeAnnouncement', announcement => {
        this.setAnnouncement(announcement.userMessage)
        if (announcement.isError) {
          this.setAnnouncementWarning()
        }
      })
    }
  }
</script>
